import { render, staticRenderFns } from "./VTableRow.vue?vue&type=template&id=20fa4471&"
import script from "./VTableRow.vue?vue&type=script&lang=js&"
export * from "./VTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports